import { render, staticRenderFns } from "./MenuItemGroup.html?vue&type=template&id=401e011d&scoped=true&"
import script from "./MenuItemGroup.ts?vue&type=script&lang=ts&"
export * from "./MenuItemGroup.ts?vue&type=script&lang=ts&"
import style0 from "./MenuItemGroup.scss?vue&type=style&index=0&id=401e011d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401e011d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListGroup,VListItemContent,VListItemIcon,VListItemTitle})
